// extracted by mini-css-extract-plugin
export default {"productCarousel":"q1-z"};